import { Outlet } from 'react-router-dom';
import { SkinSessionProvider } from '../../salon/context/SkinSessionContext';
import { OrgPlanProvider } from '../context/OrgPlanContext';
import { MakeupHairNavProvider } from '../context/MakeupHairNavContext';
import MakeupHairAppHeader from './MakeupHairAppHeader';
import SalonLandingBackground, {
  KIOSK_PAGE_KEYS,
} from '../../salon/components/SalonLandingBackground';
import { PageBackgroundSync } from '../../salon/components/PageBackgroundSync';
import PageFooter from '../../salon/components/PageFooter';
import { BeautyProductProvider } from '../../../beauty-shared/context/BeautyProductContext';
import { BEAUTY_PRODUCTS } from '../../../beauty-shared/config/saasModules';
import '../../salon/components/SalonLandingBackground.css';
import '../../shared/EnterpriseKioskTabletFooter.css';
import '../styles/CommonBackground.css';
import ModernDialogHost from '../../admin-shared/ModernDialogHost';

export default function MakeupHairAuthLayout({
  product = BEAUTY_PRODUCTS.makeup,
  naturals = true,
}) {
  return (
    <BeautyProductProvider product={product} naturals={naturals}>
      <SkinSessionProvider>
        <OrgPlanProvider>
          <MakeupHairNavProvider>
            <PageBackgroundSync />
            <div className="naturals-makeup-landing-shell naturals-salon-lux fi-lux-theme">
              <SalonLandingBackground pageKey={KIOSK_PAGE_KEYS.SALON_ENTRY} source="pageSetup" />
              <div className="naturals-makeup-landing-shell__content naturals-salon-lux__content">
                <MakeupHairAppHeader />
                <Outlet />
                <PageFooter />
              </div>
              <ModernDialogHost />
            </div>
          </MakeupHairNavProvider>
        </OrgPlanProvider>
      </SkinSessionProvider>
    </BeautyProductProvider>
  );
}
